import styled from "styled-components";

const Title = styled.div`
    font-weight: bold;
    font-size: 16px;
    align-self: ${props => props.alignSelf || "flex-start"}
`;

export default Title;